import { useEffect, useState } from 'react';

export default function InputSelect({
  label,
  inputId,
  placeholder,
  value = '',
  setValue,
  required = false,
  list,
  isValid,
  setIsValid = () => {},
  externalError = '',
}) {
  const [validText, setValidText] = useState('');

  useEffect(() => {
    if (required && !value) {
      return setValidText('필수 선택값입니다.');
    }

    setValidText('');
  }, [required, isValid, value]);

  const displayError = externalError || (!isValid ? validText : '');
  const hasError = !!displayError;

  return (
    <div className="w-full flex justify-between items-center mb-2">
      <label htmlFor={inputId} className="w-1/5 text-explorer font-semibold text-base">
        {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
      </label>
      <select
        id={inputId}
        className={`w-3/5 text-center rounded-lg bg-operator text-giver font-semibold ${
          hasError ? 'border-2 border-red-500' : ''
        }`}
        value={value}
        onChange={(e) => {
          if (e.target.value) {
            setValue(e.target.value);
            setIsValid(true);
            return;
          }

          setValue(e.target.value);
          setIsValid(false);
        }}
      >
        <option key="default" value="">
          {placeholder}
        </option>
        {Object.keys(list).map((key) => (
          <option key={key} value={key}>
            {list[key]}
          </option>
        ))}
      </select>
      <div className="ml-4 w-1/5 text-red-400 text-sm">{displayError}</div>
    </div>
  );
}
